var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-app-price"
  }, [_c('div', {
    staticClass: "app-price",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.goAppDownloadPage.apply(null, arguments);
      }
    }
  }, [_c('ycf-image', {
    staticClass: "price-bg",
    attrs: {
      "src": "/srcv2/images/app_price_bg.png"
    }
  }), _c('span', {
    staticClass: "reduce-price"
  }, [_vm._v("云客赞APP下单立减￥"), typeof _vm.reducePrice == 'number' ? _c('i', [_vm._v(_vm._s(_vm.reducePrice.toFixed(2)))]) : _vm._e()]), _c('span', {
    staticClass: "btn-download"
  }, [_vm._v("去下载")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };